// extracted by mini-css-extract-plugin
export var chip = "_5k-0";
export var filterDropdown = "_5k-5";
export var filterItem = "_5k-6";
export var icon = "_5k-1";
export var removeButton = "_5k-3";
export var removeIcon = "_5k-4";
export var separator = "_5k-2";